import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import NotificationPO from "./NotificationPO";
import NotificationSO from "./NotificationSO";

const NotificationListing = () => {
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("po");

  useEffect(() => {
    if (location.state?.selectedTab === "sales order") {
      setActiveTab("so");
    } else if (location.state?.selectedTab === "purchase order") {
      setActiveTab("po");
    }
  }, [location.state]);

  return (
    <div>
      <div
        style={{
          background: "#fff",
          margin: "0 10px",
          borderBottom: "1px solid #E5E7EB",
          marginTop: "-18px"
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "30px",
          }}
        >
          <div
            onClick={() => setActiveTab("po")}
            style={{
              cursor: "pointer",
              padding: "16px 0",
              fontWeight: 600,
              color: activeTab === "po" ? "#FD7545" : "#6B7280",
              borderBottom:
                activeTab === "po"
                  ? "3px solid #FD7545"
                  : "3px solid transparent",
              transition: "all 0.3s ease",
            }}
          >
            Purchase Order
          </div>

          <div
            onClick={() => setActiveTab("so")}
            style={{
              cursor: "pointer",
              padding: "16px 0",
              fontWeight: 600,
              color: activeTab === "so" ? "#FD7545" : "#6B7280",
              borderBottom:
                activeTab === "so"
                  ? "3px solid #FD7545"
                  : "3px solid transparent",
              transition: "all 0.3s ease",
            }}
          >
            Sales Order
          </div>
        </div>
      </div>

      {/* Content */}
      <div
        style={{
          padding: "20px 0px",
        }}
      >
        {activeTab === "po" && (
          <NotificationPO isNotification={true} />
        )}

        {activeTab === "so" && (
          <NotificationSO isNotification={true} />
        )}
      </div>
    </div>
  );
};

export default NotificationListing;